<template>
  <div class="abput-tab">
     <div class="about-title">关于我们</div>
        <div
          class="about-item"
          v-for="(item, index) in $store.state.aboutList"
          :key="index"
          :class="{selected:item.isSelected}"
          @click="aboutTab(item)"
        >{{item.name}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  methods: {
      aboutTab(item) {
      for (let i of this.$store.state.aboutList) {
        i.isSelected = false;
      }
      if(item.name=="关于聚师傅"){
        this.$router.push({ path: "/about" });
      }
      if(item.name=="联系我们"){
        this.$router.push({ path: "/about/contact" });
      }
      item.isSelected = true;
    }
  }
}
</script>

<style lang='scss' scoped>
.abput-tab{
    background: #ffffff;
    padding-bottom: 30px;
}
</style>
